module.exports = __webpack_public_path__ + "static/img/userCenterDetail-addressIcon.c11e67cd.png";